import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconInstagramStyle0 = cosmosIconCss;

const CosmosIconInstagram$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconInstagram extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0693201474111479f1a179a7a3feef404ced6a7f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fa7b7d187c384a9a7de0382b943474f40c19355c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a2105adfd2d731c18ae8e5733eeb6ca6e977704a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.973 3H7.666a5.833 5.833 0 0 0-1.948.364 4.153 4.153 0 0 0-2.354 2.354A5.833 5.833 0 0 0 3 7.666v6.614c.01.665.132 1.324.364 1.948a4.152 4.152 0 0 0 2.354 2.355 5.833 5.833 0 0 0 1.948.364c.33 0 .572.007.87.017.477.016 1.095.036 2.437.036 2.183 0 2.451 0 3.307-.053a5.833 5.833 0 0 0 1.948-.364 4.152 4.152 0 0 0 2.355-2.355 5.833 5.833 0 0 0 .364-1.948c0-.33.007-.572.017-.87A64.93 64.93 0 0 0 19 10.973c0-2.183 0-2.45-.053-3.307a5.833 5.833 0 0 0-.364-1.948 4.152 4.152 0 0 0-2.355-2.354A5.833 5.833 0 0 0 14.28 3h-3.307Zm0 1.445c2.14 0 2.397 0 3.21.053a4.448 4.448 0 0 1 1.489.268 2.612 2.612 0 0 1 1.53 1.53c.188.485.29 1 .3 1.52v6.421a4.442 4.442 0 0 1-.268 1.488 2.612 2.612 0 0 1-1.53 1.53c-.486.189-1 .29-1.52.3H7.763a4.444 4.444 0 0 1-1.488-.267 2.611 2.611 0 0 1-1.53-1.53c-.189-.486-.29-1-.3-1.52 0-.327-.008-.56-.018-.848a60.42 60.42 0 0 1-.036-2.363c0-2.14 0-2.398.054-3.211a4.45 4.45 0 0 1 .267-1.488c.257-.72.817-1.29 1.53-1.562a4.441 4.441 0 0 1 1.52-.268c.327 0 .56-.008.848-.017a59.35 59.35 0 0 1 2.363-.036Zm-4.12 6.582a4.12 4.12 0 1 1 8.24 0 4.12 4.12 0 0 1-8.24 0Zm4.12 2.675a2.676 2.676 0 1 1 0-5.35 2.676 2.676 0 0 1 0 5.35Zm4.281-5.993a.963.963 0 1 0 0-1.927.963.963 0 0 0 0 1.927Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconInstagramStyle0; }
}, [1, "cosmos-icon-instagram", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-instagram"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-instagram":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInstagram$1);
            }
            break;
    } });
}

const CosmosIconInstagram = CosmosIconInstagram$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconInstagram, defineCustomElement };
